<template>
    <div class="content-box">
        <Title/>
        <div class="title-right">
            <!-- <img
              src="https://www.100ec.cn/Public/home/images/dd.gif"
            /> -->
        </div>
        <el-menu
        :default-active="activeIndex"
        class="el-menu-demo"
        mode="horizontal">
            <el-menu-item
            :index="String(index + 1)"
            v-for="(i, index) of dataNav"
            :key="index"
            @click="handleSelect(index)">
            {{i.label}}</el-menu-item>
        </el-menu>

        <div class="mobile-select">
            <el-select
            v-model="name"
            @change="handleSelect2">
                <el-option
                v-for="item in dataNav"
                :key="item.value"
                :label="item.label"
                :value="item.value">
                </el-option>
            </el-select>
        </div>

        <Textlist/>
    </div>
</template>

<script>
export default {
    name: "broadCast",
    data() {
        return {
            activeIndex: '1',
            name: '滚动播报',
            dataNav: [
                {
                    value: 4,
                    label: '滚动播报'
                },
                {
                    value: '产业数字化',
                    label: '产业数字化'
                },
                {
                    value: '产业 互联网',
                    label: '产业互联网'
                },
                {
                    value: '数字经济',
                    label: '数字经济'
                },
                {
                    value: '企业 数字化',
                    label: '企业数字化'
                },
                {
                    value: '数字 供应链',
                    label: '数字供应链'
                },
                {
                    value: 'B2B',
                    label: 'B2B'
                },
                {
                    value: '供应链',
                    label: '供应链'
                },
                {
                    value: '产业链',
                    label: '产业链'
                },
                {
                    value: '工业 互联网',
                    label: '工业互联网'
                },
                {
                    value: '供应链金融',
                    label: '供应链金融'
                },
                // {
                //     value: '智能制造',
                //     label: '智能制造'
                // },
                {
                    value: 'C2M',
                    label: 'C2M'
                },
                {
                    value: '产业集群',
                    label: '产业集群'
                },
                {
                    value: '云计算',
                    label: '云计算'
                },
                {
                    value: 'B2B 营销',
                    label: 'B2B营销'
                },
                {
                    value: 'B2B 交易',
                    label: 'B2B交易'
                },
                {
                    value: '钢铁 电商',
                    label: '钢铁电商'
                },
                {
                    value: '工业品',
                    label: '工业品电商'
                },
                {
                    value: '快消品',
                    label: '快消品'
                },
                {
                    value: '元器件',
                    label: '元器件电商'
                },
                {
                    value: '企业购',
                    label: '企业购'
                },
                {
                    value: '企业服务',
                    label: '企业服务'
                },
                {
                    value: 'MRO',
                    label: 'MRO'
                },
                {
                    value: '浅析 B2B',
                    label: '浅析'
                },
                {
                    value: '实战 B2B',
                    label: '实战'
                },
                {
                    value: '案例 B2B',
                    label: '案例'
                },
                {
                    value: '研报 B2B',
                    label: '研报'
                },
                {
                    value: '盘点 B2B',
                    label: '盘点'
                },
                {
                    value: '分析 B2B',
                    label: '分析'
                },
                {
                    value: 'PPT B2B',
                    label: 'PPT'
                },
                {
                    value: '信息图 B2B',
                    label: '信息图'
                },
            ],
            params: {
                json: 2,
                filter: [
                    '张周平',
                    '曹磊'
                ]
            }
        }
    },
    created() {
        this.$store.commit('textparams', this.params)
        this.$store.commit('changeKeys', this.dataNav[0].value)
        this.$store.dispatch('getText')
    },
    methods: {
        handleSelect(index) {
            if(typeof(this.dataNav[index].value) == 'number') {
                this.params.json = 2
            }else {
                this.params.json = 0
            }
            this.$store.commit('textparams', this.params)
            this.$store.commit('changeKeys', this.dataNav[index].value)
            this.$store.dispatch('getText')
        },
        handleSelect2(value) {
            if(typeof(value) == 'number') {
                this.params.json = 2
            }else {
                this.params.json = 0
            }
            this.$store.commit('textparams', this.params)
            this.$store.commit('changeKeys', value)
            this.$store.dispatch('getText')
        },
    },
}
</script>
<style scoped>
.title{
  position: relative;
}
.title-right{
    position: absolute;
    left: 195px;
    top: 65px;
}
.title-right img{
  width: 580px;
  height: 70px;
}
@media (max-width: 1100px) {
  .title-right{
    position: static;
    margin: 10px 0;
}
.title-right img{
  width: 100%;
  height: 50px;
}
}
</style>